import React, { useEffect, useState } from 'react';
import Skeleton from 'react-loading-skeleton';

const Homecount = () => {
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const timer = setTimeout(() => setLoading(false), 1000);
        return () => clearTimeout(timer); 
    }, []);

    return (
        <section id="featured-services" className="featured-services section light-background">
            <div className="container">
                <div className="row gy-4">
                    {loading ? (
                        <>
                            <div className="col-6 col-lg-4 col-xl-4">
                                <div className="service-item d-flex">
                                    <div className="icon flex-shrink-0 skeleton-icon"></div>
                                    <div>
                                        <h4 className="title skeleton-text"><Skeleton width={50} height={30}/></h4>
                                        <p className="description skeleton-text"><Skeleton width={60} height={10}/></p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-6 col-lg-4 col-xl-4">
                                <div className="service-item d-flex">
                                    <div className="icon flex-shrink-0 skeleton-icon"></div>
                                    <div>
                                        <h4 className="title skeleton-text"><Skeleton width={50} height={30}/></h4>
                                        <p className="description skeleton-text"><Skeleton width={60} height={10}/></p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-6 col-lg-4 col-xl-4">
                                <div className="service-item d-flex">
                                    <div className="icon flex-shrink-0 skeleton-icon"></div>
                                    <div>
                                        <h4 className="title skeleton-text"><Skeleton width={50} height={30}/></h4>
                                        <p className="description skeleton-text"><Skeleton width={60} height={10}/></p>
                                    </div>
                                </div>
                            </div>
                        </>
                    ) : (
                        <>
                            <div className="col-6 col-lg-4 col-xl-4">
                                <div className="service-item d-flex">
                                    <div className="icon flex-shrink-0"><i className="bi bi-buildings" /></div>
                                    <div>
                                        <h4 className="title"><a href="#" className="stretched-link">200+</a></h4>
                                        <p className="description">Companies</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-6 col-lg-4 col-xl-4">
                                <div className="service-item d-flex">
                                    <div className="icon flex-shrink-0"><i className="bi bi-person" style={{ color: 'purple' }} /></div>
                                    <div>
                                        <h4 className="title"><a href="#" className="stretched-link">10K+</a></h4>
                                        <p className="description">Employees</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-6 col-lg-4 col-xl-4">
                                <div className="service-item d-flex">
                                    <div className="icon flex-shrink-0"><i className="bi bi-geo-alt-fill" style={{ color: 'red' }} /></div>
                                    <div>
                                        <h4 className="title"><a href="#" className="stretched-link">10+</a></h4>
                                        <p className="description">Cities</p>
                                    </div>
                                </div>
                            </div>

                            <div className="col-6 col-lg-4 col-xl-4 d-block d-sm-none">
                                <div className="service-item d-flex">
                                    <div className="icon flex-shrink-0"><i className="bi bi-geo-alt-fill" style={{ color: 'green' }} /></div>
                                    <div>
                                        <h4 className="title"><a href="#" className="stretched-link">5+</a></h4>
                                        <p className="description">Country</p>
                                    </div>
                                </div>
                            </div>
                        </>
                    )}
                </div>
            </div>
        </section>
    );
};

export default Homecount;
